<template>
  <div v-if="entity" class="card">
    <div class="container-fluid p-3">
      <b-row>
        <div class="col-xl-3 col-comment">
          <job-membership-card :jobIds="jobs"></job-membership-card>
        </div>
        <div class="col-xl-6 col-header">
          <b-card no-body>
            <b-card-header size="sm">

              <div class="d-flex justify-content-between align-items-start">
                <h2>{{ name ? name : 'No Name' }}</h2>
                <div>
                  <b-button v-b-popover.hover.bottom="'Add to cart'" variant="outline-primary" class="mx-2 img-icon img-icon-cart-add-9" size="sm"
                            @click="addToCart(entity)" v-if="!addedInCart"></b-button>
                  <b-button v-b-popover.hover.bottom="'Remove from cart'" variant="outline-danger" class="mx-2 img-icon img-icon-cart-remove-9" size="sm"
                            @click="removeFromCart()" v-if="addedInCart"></b-button>
                  <b-button v-if="downloadURL && !isDownloaded" v-b-popover.hover.bottom="'Download Entity'" variant="outline-primary" class="mx-2 img-icon img-icon-cloud-data-download-2" size="sm"
                            @click="downloadFile()"></b-button>
                  <b-button v-else :disabled="isDownloaded" variant="outline-primary" class="mx-2 img-icon img-icon-cloud-data-download-2" size="sm"
                            ></b-button>

                  <b-button size="sm" variant="outline-danger" class="mx-2" @click="deleteThisEntity()">X</b-button>
<!--                  <b-dropdown variant="outline-primary" class="m-2 p-0" size="sm">-->
<!--                    <b-dropdown-item @click="deleteThisEntity()">Delete</b-dropdown-item>-->
<!--                  </b-dropdown>-->

                </div>
              </div>
              <div>
                <div>
                  <small class="text-muted">{{ dateUpdated | moment("from") }}</small><br>
                  <div><small>{{ size | bytes }}</small></div>
                  <checksum-list :checksums="entity.getAlternateChecksums().toObject()"></checksum-list>
                </div>

                <div class="mt-auto"/>
              </div>
            </b-card-header>

            <entity-media-wrapper :entity="entity.toObject()"></entity-media-wrapper>

            <b-card-footer>
              <vue-tags-input
                input-id="file-detail-tags"
                v-model="tag"
                :tags="tags"
                @before-adding-tag="beforeTagAdd"
                @before-deleting-tag="beforeTagDelete"
              />
            </b-card-footer>
          </b-card>

          <comment-card :entityId=entityId></comment-card>

        </div>
        <div class="col-xl-3 col-metadata">
          <metadata-card :entity="entity"></metadata-card>
        </div>
      </b-row>
    </div>
    <iframe id="my_iframe" style="display:none;"></iframe>
  </div>
</template>

<script>
import { createTag, VueTagsInput } from '@johmun/vue-tags-input';

import CommentCard from '#/ui/Components/CommentCard.vue';
import MetadataCard from '#/ui/Components/MetadataCard.vue';
import JobMembershipCard from '#/ui/Components/JobMembershipCard.vue';
import { EntityId } from '#/protobuf/entity_pb';
import { EntityTagUpdateRequest } from '#/protobuf/service_modification_pb';
import { DeleteEntityRequest } from '#/protobuf/service_deletion_pb';
import ChecksumList from '#/ui/Components/ChecksumList.vue';
import EntityMediaWrapper from '#/ui/Components/Entities/EntityMediaWrapper.vue';
import { EntityGetSession } from '#/services/entities';

export default {
  components: {
    EntityMediaWrapper,
    ChecksumList,
    CommentCard,
    MetadataCard,
    JobMembershipCard,
    VueTagsInput,
  },
  created() {
    return this.session.load().then(() => {
      const entity = this.session.entity.toObject();
      if (entity) {
        entity.expandedTagsList.forEach((tag) => {
          const obj = createTag(tag.tag, this.tags);
          this.tags.push(obj);
        });
      }
    });
  },
  data() {
    const { size, checksum } = this.$route.params;
    const eId = new EntityId();
    eId.setSize(Number(size));
    eId.setChecksum(checksum);
    return {
      session: new EntityGetSession([eId]),
      tag: '',
      tags: [],
      downloadList: [],
      isDownloaded: false,
    };
  },
  computed: {
    addedInCart() {
      return this.$store.getters['datacart/cartItems'].filter((item) => item.id === this.entityId.toString()).length === 1;
    },
    entity() {
      return this.session.entity;
    },
    entityId() {
      const { size, checksum } = this.$route.params;
      const entityId = new EntityId();
      entityId.setSize(size);
      entityId.setChecksum(checksum);
      return entityId;
    },
    jobs() {
      if (this.session.entity) {
        return this.session.entity.getExpandedJobMembershipList();
      }
      return [];
    },
    name() {
      return this.entity.getName();
    },
    size() {
      return this.entity.getSize();
    },
    checksum() {
      return this.entity.getChecksum();
    },
    dateUpdated() {
      return this.entity.getDateLastUpdated();
    },
    // derivativeVideoURL() {
    //   return derivativeVideoURLsForVideoPlayer(this.entity);
    // },
    downloadURL() {
      const entity = this.entity.toObject();
      if (entity.expandedDownloadsList && entity.expandedDownloadsList.length > 0) {
        const { download } = entity.expandedDownloadsList[0];
        console.info('download url:', download);
        return download;
      }
      return undefined;
    },
  },
  methods: {
    downloadFile() {
      this.isDownloaded = true;
      this.$store.dispatch('entities/updateDownloadList', this.downloadURL);

      // const entity = this.entity.toObject();
      // if (entity.expandedDownloadsList && entity.expandedDownloadsList.length > 0) {
      //   const download = entity.expandedDownloadsList[0];
      //   this.$store.dispatch('entities/updateDownloadList', download.download);
      // }

      // this loop will download all derivatives too
      // if (entity.expandedDerivativesList && entity.expandedDerivativesList.length > 0) {
      //   entity.expandedDerivativesList.forEach((entityCopy) => {
      //     entityCopy.entity.expandedDownloadsList.forEach((download) => {
      //       this.$store.dispatch('entities/updateDownloadList', download.download);
      //     });
      //   });
      // }
    },
    beforeTagAdd(obj) {
      const tag = [obj.tag.text];
      const request = new EntityTagUpdateRequest();
      request.setEntityId(this.entityId);
      request.setTagsToAddList(tag);
      this.$store.dispatch('entities/updateTags', request).then((response) => {
        obj.addTag();
      }).catch((error) => {
        alert('Error adding tag', error);
      });
    },
    beforeTagDelete(obj) {
      const tag = [obj.tag.text];
      const request = new EntityTagUpdateRequest();
      request.setEntityId(this.entityId);
      request.setTagsToRemoveList(tag);
      this.$store.dispatch('entities/updateTags', request).then((response) => {
        obj.deleteTag();
      }).catch((error) => {
        alert('Error removing tag', error);
      });
    },
    deleteThisEntity() {
      this.$bvModal.msgBoxConfirm('Do you really want to delete this record? This cannot be undone.', {
        title: 'Remove Record',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DELETE',
        cancelTitle: 'NO',
        headerClass: 'align-items-center',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then((userAcceptedDelete) => {
        if (userAcceptedDelete) {
          const req = new DeleteEntityRequest();
          req.setEntityidsList([this.entityId]);
          this.$store.dispatch('entities/delete', req).then(() => {
            this.$router.push({ path: '/home/', project: this.$route.params.project });
          }).catch(() => {
          });
        }
      }).catch(() => {
      });
    },
    addToCart(entity) {
      this.$store.dispatch('datacart/addToCart', entity.toObject());
    },
    removeFromCart() {
      this.$store.dispatch('datacart/removeFromCart', { id: this.entityId.toString() });
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1200px) {
  .col-comment { order: 2;}
  .col-header { order: 1;}
  .col-metadata { order: 3;}
}

.vue-tags-input {
  max-width: 100% !important;
}
</style>
